import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Hook para aplicar cores dinâmicas do tema
 * Carrega as cores do backend e aplica como CSS custom properties
 */
const useTheme = () => {
  const [theme, setTheme] = useState({
    primary_color: "#14453D",
    secondary_color: "#25D366",
    background_color: "#FFFFFF",
    text_color: "#1F2937"
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTheme = async () => {
      try {
        const response = await axios.get(`${API}/settings/theme`);
        const newTheme = response.data;
        setTheme(newTheme);
        
        // Apply CSS custom properties to root element
        const root = document.documentElement;
        root.style.setProperty('--color-primary', newTheme.primary_color || "#14453D");
        root.style.setProperty('--color-secondary', newTheme.secondary_color || "#25D366");
        root.style.setProperty('--color-background', newTheme.background_color || "#FFFFFF");
        root.style.setProperty('--color-text', newTheme.text_color || "#1F2937");
        
        // Generate hover and transparency variants
        root.style.setProperty('--color-primary-hover', adjustBrightness(newTheme.primary_color, 20));
        root.style.setProperty('--color-primary-10', hexToRgba(newTheme.primary_color, 0.1));
        root.style.setProperty('--color-primary-20', hexToRgba(newTheme.primary_color, 0.2));
        
      } catch (error) {
        console.error('Failed to fetch theme:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchTheme();
  }, []);

  return { theme, loading };
};

/**
 * Adjust brightness of a hex color
 */
function adjustBrightness(hex, percent) {
  if (!hex) return "#14453D";
  
  let r = parseInt(hex.slice(1, 3), 16);
  let g = parseInt(hex.slice(3, 5), 16);
  let b = parseInt(hex.slice(5, 7), 16);
  
  r = Math.min(255, Math.floor(r * (100 + percent) / 100));
  g = Math.min(255, Math.floor(g * (100 + percent) / 100));
  b = Math.min(255, Math.floor(b * (100 + percent) / 100));
  
  return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
}

/**
 * Convert hex to rgba
 */
function hexToRgba(hex, alpha) {
  if (!hex) return "rgba(20, 69, 61, 0.1)";
  
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export default useTheme;
